const APISettings = {
  aiUrl: process.env.PREACT_APP_API_AI_URL,
  baseUrl: process.env.PREACT_APP_API_URL,
  apiKey: process.env.PREACT_APP_API_KEY,
}

export default APISettings
